import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Loginpage from './pages/login';
import Dashboard from './pages/dashboard';
import Noaccess from './pages/no-access';
import Eventmanagement from './pages/eventmanagement';
import Booking from './pages/booking';
import Error from './pages/error';
import Contentmangemnt1 from './pages/contentmanagement1';
import Contentmangemnt2 from './pages/contentmanagement2';
import Contentmangemnt3 from './pages/contentmanagement3';
import Categories from './pages/categories';
import Contentmangemnt4 from './pages/contentmanagement4';
import Exhibitors from './pages/Exhibitors';


const Paths = () => {
    return ( 
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Loginpage />} />
                <Route path='/dashboard' element={ <Dashboard />} />  
                <Route path='/no-access' element={ <Noaccess /> } />   
                <Route path='/event-management' element={ <Eventmanagement /> } />   
                <Route path='/booking-management' element={ <Booking /> } /> 
                <Route path='*' element={ <Error />} /> 
                <Route path='/content-management-navigations' element={  <Contentmangemnt1 />} />
                    <Route
                    path="/content-management-popups"
                        element={<Contentmangemnt2 />}
                        />
                <Route path='/content-management-home' element={ <Contentmangemnt3 />} />
                <Route path='/categories' element={<Categories />} /> 
                <Route path='/content-management-Exhibitors' element={ <Contentmangemnt4 />} />
                <Route path='/Exhibitors-management' element={  <Exhibitors />} />  


            </Routes>
        </BrowserRouter>
     );
}
 
export default Paths;